/**
 * Aba Histórico do editor na sessão. O pai já carregou o estado; aqui só se desenha.
 */
import {
  ROTULO_HISTORICO_INDISPONIVEL,
  ROTULO_HISTORICO_VAZIO,
  ROTULO_NOTA,
  type HistoricoEditor,
} from './editorNaRevisaoContrato';

export interface EditorHistoricoProps {
  historico: HistoricoEditor;
}

/** Data válida vira pt-BR. Qualquer outro `at` volta cru, para o instante não sumir. */
function textoDoInstante(at: string): string {
  if (typeof at === 'string' && at !== '') {
    const data = new Date(at);
    if (!Number.isNaN(data.getTime())) return data.toLocaleString('pt-BR');
  }
  return at;
}

export function EditorHistorico(props: EditorHistoricoProps): JSX.Element {
  const { historico } = props;

  if (historico.estado === 'carregando') {
    return <p className="text-sm text-ink-muted">Carregando histórico…</p>;
  }

  if (historico.estado === 'indisponivel') {
    return (
      <p className="text-sm text-ink" data-editor-historico-estado="indisponivel">
        {ROTULO_HISTORICO_INDISPONIVEL}
      </p>
    );
  }

  if (historico.estado === 'vazio') {
    return (
      <p className="text-sm text-ink" data-editor-historico-estado="vazio">
        {ROTULO_HISTORICO_VAZIO}
      </p>
    );
  }

  return (
    <ul className="m-0 flex list-none flex-col p-0">
      {historico.entradas.map((entrada, indice) => {
        const temDuracao = typeof entrada.elapsedMs === 'number';
        return (
          <li
            key={`${entrada.at}-${entrada.rating}-${indice}`}
            className="flex flex-wrap items-baseline justify-between gap-2 border-b border-edge py-2 text-sm last:border-b-0"
          >
            <span className="font-medium text-ink">{ROTULO_NOTA[entrada.rating]}</span>
            <span className="flex flex-wrap items-baseline gap-3">
              <time className="text-ink-secondary" dateTime={entrada.at}>
                {textoDoInstante(entrada.at)}
              </time>
              {temDuracao ? (
                <span className="text-ink-secondary">{`${entrada.elapsedMs} ms`}</span>
              ) : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
